const IamAssociation = () => {
    return (
        <div>
            <h1>Je suis une Association</h1>
        </div>
    );
};

export default IamAssociation;
